import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
let date = new Date();
export default new Vuex.Store({
	state: {
		token: '',
		profile: {opts: []},
		loading: !1,//加载中
		leftOff: [!1, !1, !1, !1, !1, !1, !1, !1],
		pasOff: !1,//修改密码弹框
		pageSize: 20,//分页显示数量
		leftOff1: !0,
		clientHeight: document.documentElement.clientHeight - 170,
		theDay: date .getFullYear() +'-'+ (date .getMonth()+1) +'-'+ date .getDate(),
		keepAliveOff: !1,
		newDafa: {
			off: !1,
			data: ''
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js